var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"preview-product-list"},[_c('ProductListingPage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }